export class UnifiedDatabaseRecord {
    'name';
    'serverId';
    'schemaCount';
    'schemas';
    'recordType';
    'snapshot';
    'resource';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "serverId",
            "baseName": "serverId",
            "type": "string",
            "format": ""
        },
        {
            "name": "schemaCount",
            "baseName": "schemaCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "schemas",
            "baseName": "schemas",
            "type": "Array<UnifiedSchemaRecord>",
            "format": ""
        },
        {
            "name": "recordType",
            "baseName": "record_type",
            "type": "string",
            "format": ""
        },
        {
            "name": "snapshot",
            "baseName": "snapshot",
            "type": "DBSnapshotMetadata",
            "format": ""
        },
        {
            "name": "resource",
            "baseName": "resource",
            "type": "DBResourceMetadata",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UnifiedDatabaseRecord.attributeTypeMap;
    }
    constructor() {
    }
}
